module.exports = __webpack_public_path__ + "static/img/06.8927eed1.png";